module.exports =
  '_RANKING_GROUP':
    'LIST_TITLE': "グループ"
    'JOINED_LIST': 'イベント一覧'
    'PARTICIPANTS' : '参加'
    'NONPARTICIPANTS': '不参加'
    'EVENT_RANK':
      'RANKING_NAME': 'ランキング'
      'AVG_SCORE': '平均スコア'
      'AVG_PUTT': '平均パット'
      'RAT_PAR_ON': 'パーオン率'
      'RAT_BIRDIE': 'バーディ率'
      'RAT_PAR': 'パー率'
      'SCORE_DETAILS': 'スコア詳細を見る'
      'CLOSE': '閉じる'
      'UNNAMED': '名称未設定'
      'SCORE_ANALYSIS': '全体のスコア分析'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-ranking/i18n/ja.coffee